import { createSlice } from '@reduxjs/toolkit';

export const messageSlice = createSlice({
  name: 'message',
  initialState: {
    showMessageItemDetail: 0,
    showPagination: 1,
    messageDetail: {},
    listCheckBox: false,
    messageUpdatedAt: 0
  },
  reducers: {
    setListCheckBox: (state, action) => {
      state['listCheckBox'] = action.payload;
    },
    notifyMessagesUpdated: (state) => {
      state['messageUpdatedAt'] += 1;
    },
    initializeMessageState: (state, action) => {
      state['showMessageItemDetail'] = 0;
      state['showPagination'] = 1;
      state['messageDetail'] = {};
    },
    showMessageDetail: (state, action) => {
      state['showMessageItemDetail'] = 1;
      state['showPagination'] = 0;
      state['messageDetail'] = action.payload;
    },
    setShowMessageItemDetail: (state, action) => {
      state['showMessageItemDetail'] = action.payload;
    },
    setShowPagination: (state, action) => {
      state['showPagination'] = action.payload;
    },
    setMessageDetail: (state, action) => {
      state['messageDetail'] = action.payload;
    }
  }
});

export const { setListCheckBox, showMessageDetail, initializeMessageState, setShowMessageItemDetail, setShowPagination, setMessageDetail, notifyMessagesUpdated } = messageSlice.actions;

export default messageSlice.reducer;
